<template>
  <TableLayout>
    <template v-slot:table-wrap>
      <ul class="toolbar">
        <el-button type="primary" :loading="isWorking.export" @click="exportExcel">导出明细</el-button>
      </ul>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        border
      >
        <el-table-column prop="openid" label="用户" min-width="100px" align="center"></el-table-column>
        <el-table-column prop="id" label="订单编号" min-width="100px" align="center"></el-table-column>
        <el-table-column prop="transactionId" label="微信交易号" min-width="100px" align="center"></el-table-column>
        <el-table-column prop="billDate" label="支付时间" min-width="100px" align="center"></el-table-column>
        <el-table-column prop="totalFee" label="支付金额" min-width="100px" align="center"></el-table-column>
        <el-table-column prop="refundSuccessDate" label="退款时间" min-width="100px" align="center"></el-table-column>
        <el-table-column prop="refundFee" label="退款金额" min-width="100px" align="center"></el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'

export default {
  name: 'BaseParam',
  extends: BaseTable,
  components: { TableLayout, Pagination },

  data () {
    return {
      // 搜索
      searchForm: {
        endDate: '',
        startDate: '',
        type: '',
        isBikeFee: 1
      }
    }
  },
  created () {
    this.config({
      module: '系统基础配置表',
      api: '/business/noBikeBillDetail',
    })
  },
  methods: {
    reload(target) {
      this.searchForm = target
      this.tableData.pagination.pageIndex = 1
      this.search()
    }
  },
}
</script>
